"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _InfiniteTiles = _interopRequireDefault(require("./InfiniteTiles"));

var _TileCollection = _interopRequireDefault(require("./TileCollection"));

var _ShutterstockDetails = _interopRequireDefault(require("./ShutterstockDetails"));

var _Shutterstock = require("../../actions/Shutterstock");

var _Constants = require("../../Constants");

var _Actions = require("../../actions/Actions");

var _Panel = require("../../selectors/Panel");

var ShutterstockTile = _styledComponents.default.div.withConfig({
  displayName: "Shutterstock__ShutterstockTile",
  componentId: "sc-1c1qwtg-0"
})(["position:absolute;display:flex;align-items:center;justify-content:center;width:100%;height:100%;left:0;top:0;background-color:", ";cursor:pointer;"], _colors.GYPSUM);

var ShutterstockThumbnailImage = _styledComponents.default.img.withConfig({
  displayName: "Shutterstock__ShutterstockThumbnailImage",
  componentId: "sc-1c1qwtg-1"
})(["max-height:100%;max-width:100%;"]);

var Shutterstock = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Shutterstock, _Component);

  function Shutterstock(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Shutterstock);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Shutterstock).call(this, props));
    _this.renderTile = _this.renderTile.bind((0, _assertThisInitialized2.default)(_this));
    _this.getRenderer = _this.getRenderer.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderStock = _this.renderStock.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderStockDetail = _this.renderStockDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelect = _this.handelSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseStockDetail = _this.handleCloseStockDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Shutterstock, [{
    key: "handelSelect",
    value: function handelSelect(event, image) {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          onTrackInteraction = _this$props.onTrackInteraction;
      onTrackInteraction('Browse Shutterstock', 'clicked-image-preview');
      onSelect(image);
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(file) {
      var onInsert = this.props.onInsert;
      onInsert(file);
    }
  }, {
    key: "handleCloseStockDetail",
    value: function handleCloseStockDetail() {
      var usageTrackingMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSelect = this.props.onSelect;
      onSelect(null, usageTrackingMeta);
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(tile) {
      switch (tile.get('type')) {
        case _Constants.CellTypes.FILE_DETAIL:
          return this.renderStockDetail;

        default:
          return this.renderStock;
      }
    }
  }, {
    key: "renderStockDetail",
    value: function renderStockDetail(tile) {
      var onUpdateHeight = this.props.onUpdateHeight;
      return _react.default.createElement(_ShutterstockDetails.default, {
        tile: tile,
        onClose: this.handleCloseStockDetail,
        onInsert: this.handleInsert,
        onUpdateHeight: onUpdateHeight
      });
    }
  }, {
    key: "renderStock",
    value: function renderStock(tile) {
      var _this2 = this;

      var _tile$toObject = tile.toObject(),
          image = _tile$toObject.image;

      return _react.default.createElement(ShutterstockTile, null, _react.default.createElement(ShutterstockThumbnailImage, {
        src: image.get('smallPreviewUrl'),
        draggable: false,
        onClick: function onClick(event) {
          _this2.handleSelect(event, image);
        }
      }));
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      var renderer = this.getRenderer(tile);
      return renderer(tile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          tiles = _this$props2.tiles,
          total = _this$props2.total,
          onLoadMoreImages = _this$props2.onLoadMoreImages,
          withPanelNavigator = _this$props2.withPanelNavigator;

      if (withPanelNavigator) {
        return _react.default.createElement(_TileCollection.default, {
          onLoadMoreFiles: onLoadMoreImages,
          tileRenderer: this.renderTile,
          tiles: tiles,
          total: total
        });
      }

      return _react.default.createElement(_InfiniteTiles.default, {
        onLoadMoreImages: onLoadMoreImages,
        tileRenderer: this.renderTile,
        tiles: tiles,
        total: total
      });
    }
  }]);
  return Shutterstock;
}(_react.Component);

Shutterstock.propTypes = {
  tiles: _propTypes.default.instanceOf(_immutable.default.List),
  total: _propTypes.default.number.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onLoadMoreImages: _propTypes.default.func.isRequired,
  onUpdateHeight: _propTypes.default.func.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired,
  withPanelNavigator: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedStockFile: (0, _Panel.getSelectedStockFile)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onTrackInteraction: function onTrackInteraction(name, action, meta) {
      dispatch((0, _Actions.trackInteraction)(name, action, meta));
    },
    onSelect: function onSelect(image) {
      dispatch(image ? (0, _Shutterstock.selectStockFile)(image) : (0, _Shutterstock.deselectStockFile)(null));
    },
    onUpdateHeight: function onUpdateHeight(image, height) {
      dispatch((0, _Actions.updateDetailHeight)(image, height));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Shutterstock);

exports.default = _default;
module.exports = exports.default;